import { z } from 'zod';

export const companyWebsiteCreateSchema = z
  .object({
    url: z
      .string()
      .trim()
      .min(4, 'Enter a website address')
      .max(200, 'Website must be 200 characters or fewer'),
    label: z.string().trim().max(80).optional(),
  })
  .strict();
export type CompanyWebsiteCreateInput = z.infer<typeof companyWebsiteCreateSchema>;

export const companyWebsiteSummarySchema = z.object({
  id: z.string(),
  companyId: z.string(),
  url: z.string(),
  label: z.string().nullable(),
  // MainWP linkage (v1.2): mainwpSiteId is null until the site is linked (via
  // import/backfill) — the operator cache-clear button is gated on it being set.
  // cacheLastClearedAt is the persisted timestamp of the last successful flush.
  mainwpSiteId: z.string().nullable(),
  cacheLastClearedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type CompanyWebsiteSummary = z.infer<typeof companyWebsiteSummarySchema>;

/**
 * Client-facing website summary (the portal). Deliberately omits the internal
 * fleet identifiers `mainwpSiteId` and `cacheLastClearedAt` — those are
 * operator-only linkage/telemetry and must never be disclosed to a tenant.
 * `GET /api/client/websites` returns this shape; the admin surfaces keep the
 * full `companyWebsiteSummarySchema`.
 */
export const clientCompanyWebsiteSummarySchema = companyWebsiteSummarySchema.omit({
  mainwpSiteId: true,
  cacheLastClearedAt: true,
});
export type ClientCompanyWebsiteSummary = z.infer<typeof clientCompanyWebsiteSummarySchema>;
